module.exports = __webpack_public_path__ + "static/thumb-7-eda0f49aed28ea0cbaef31e9f4472f03.jpg";